var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view'),_c('transition',{attrs:{"name":"fade-faster"}},[_c('AppLoadVue',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadApp),expression:"loadApp"}]})],1),_c('notifications',{attrs:{"group":"foo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }